export const notificacionEstatus = {
    porLeer: 221,
    leida :222,
    borrada : 223
}

export const cssColores = ['blue','maroon','purple','red','navy','olive','lime','fuchsia','teal','green']

export const letras = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','X','Y','Z']